const productTerms = {
  1:"یک ماهه",
  3: "سه ماهه",
  6: "شش ماهه",
  9: "نه ماهه",
  12: "یک ساله",
  24: "دو ساله",
  1000: "مشارکت در فروش طرح 1",
  2000: "مشارکت در فروش طرح 2",
  3000: "مشارکت در فروش طرح 3"
}

export default productTerms